import { useState } from "react";
import { Button, Card, Col, Input, InputNumber, Row, Space, Divider } from "antd";
import { SendOutlined, UserOutlined } from "@ant-design/icons";
import { useMonthlyFee } from "./useMonthlyFee";

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1;

export const MonthlyFeeWidget = () => {
  const { dispatchMutation, applyForUserMutation } = useMonthlyFee();

  const [year, setYear] = useState(currentYear);
  const [month, setMonth] = useState(currentMonth);
  const [userId, setUserId] = useState("");

  const handleDispatch = () => {
    dispatchMutation.mutate({ year, month });
  };

  const handleApplyForUser = () => {
    if (!userId.trim()) {
      return;
    }
    applyForUserMutation.mutate({ userId: userId.trim(), year, month });
  };

  return (
    <>
      <div className="page-header">
        <h3>Сарын хураамж</h3>
      </div>
      <div className="page-body">
        <Row gutter={16}>
          <Col span={12}>
            <Card title="Бөөнөөр илгээх (Production)">
              <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                <Space>
                  <span>Жил:</span>
                  <InputNumber
                    min={2020}
                    max={2030}
                    value={year}
                    onChange={(val) => setYear(val ?? currentYear)}
                  />
                  <span>Сар:</span>
                  <InputNumber
                    min={1}
                    max={12}
                    value={month}
                    onChange={(val) => setMonth(val ?? currentMonth)}
                  />
                </Space>
                <Button
                  type="primary"
                  icon={<SendOutlined />}
                  loading={dispatchMutation.isLoading}
                  onClick={handleDispatch}
                >
                  Cloud Tasks руу илгээх
                </Button>
                <p style={{ color: "#888", fontSize: 12 }}>
                  Бүх хэрэглэгчдийн сарын хураамжийг Cloud Tasks руу илгээнэ.
                </p>
              </Space>
            </Card>
          </Col>
          <Col span={12}>
            <Card title="Нэг хэрэглэгч (Development)">
              <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                <Space>
                  <span>Жил:</span>
                  <InputNumber
                    min={2020}
                    max={2030}
                    value={year}
                    onChange={(val) => setYear(val ?? currentYear)}
                  />
                  <span>Сар:</span>
                  <InputNumber
                    min={1}
                    max={12}
                    value={month}
                    onChange={(val) => setMonth(val ?? currentMonth)}
                  />
                </Space>
                <Input
                  placeholder="User ID"
                  prefix={<UserOutlined />}
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                />
                <Button
                  type="primary"
                  icon={<UserOutlined />}
                  loading={applyForUserMutation.isLoading}
                  onClick={handleApplyForUser}
                  disabled={!userId.trim()}
                >
                  Хэрэглэгчид хураамж тооцох
                </Button>
                <p style={{ color: "#888", fontSize: 12 }}>
                  Нэг хэрэглэгчийн сарын хураамжийг шууд тооцно.
                </p>
              </Space>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};
